// 工作兼职新跳转地址-美团好工作
export const getGoodjobLink = () => {
  const isTest = window.location.origin.includes('it.test');
  const url = isTest
    ? 'https://11408-smigg-sl-goodjob.ep.test.sankuai.com/m/jobs'
    : 'https://goodjob.meituan.com/m/jobs';
  return url;
};
